import { textTruncate } from '../styles/commonStyles';
import RupTooltip from './rupTooltip';
import { createStyles, makeStyles } from '@mui/styles';
import clsx from 'clsx';
import { useEffect, useRef, useState } from 'react';

// Safari workaround used here, to avoid duplicated tooltip.
// https://zzz.buzz/2017/07/31/prevent-tooltip-over-truncated-text-in-safari/

const useStyles = makeStyles(() =>
	createStyles({
		text: {
			...textTruncate,
			'&::after': {
				content: '""',
				display: 'block'
			}
		}
	})
);

export interface IWrappedTextProps {
	text: string;
	className?: string;
	tooltipMaxWidth?: string;
	testId?: string;
}

const WrappedText: React.FunctionComponent<IWrappedTextProps> = props => {
	const classes = useStyles();
	const ref = useRef<HTMLDivElement>();
	const [disableHover, setDisableHover] = useState(true);

	useEffect(() => {
		const observer = new ResizeObserver(() => {
			if (ref?.current) {
				setDisableHover(ref.current.offsetWidth >= ref.current.scrollWidth);
			}
		});

		observer.observe(ref.current);
		return () => observer.disconnect();
	}, []);

	return (
		<RupTooltip
			title={props.text}
			disableHoverListener={disableHover}
			sx={{ maxWidth: props.tooltipMaxWidth }}
			arrow
		>
			<div ref={ref} data-test-id={props.testId} className={clsx(props.className, classes.text)}>
				{props.children ?? props.text}
			</div>
		</RupTooltip>
	);
};

export default WrappedText;
